import { ReactNode } from "react";
// eslint-disable-next-line drops/no-direct-spor-import
import { BadgeProps, Badge as SporBadge } from "@vygruppen/spor-react";
import { useThemeSemantic } from "shared/theme/themeSemantic";
import { Semantics, SemanticsList } from "shared/utils/semantics";

export { SemanticsList };
export type { Semantics };

export const InternalDropsBadge = ({
  semantics,
  children,
  disabled = false,
  ...rest
}: {
  semantics: Semantics;
  children: ReactNode;
  disabled?: boolean;
} & BadgeProps) => {
  const theme = useThemeSemantic(semantics);
  return (
    <SporBadge
      size="md"
      borderWidth="1px"
      height="27px"
      fontWeight="bold"
      backgroundColor={disabled ? "transparent" : theme.colorSemanticFillPulse}
      borderColor={theme.colorSemanticOutline}
      color={theme.colorSemanticTextMain}
      fontSize="14px"
      {...rest}
    >
      {children}
    </SporBadge>
  );
};
